import {
    useCallback, useEffect, useMemo, useState,
} from 'react';
import TabsContext from './TabsContext';
import { TabId, TabsProps } from './types';

function Tabs({
    children, value, onChange, variant = 'small', isGrid, theme = 'transparent', overflow = 'scroll',
}: TabsProps) {
    const [selectedTabId, setSelectedTabId] = useState<string | undefined>();

    useEffect(() => {
        if (value !== undefined) {
            setSelectedTabId(value);
        }
    }, [setSelectedTabId, value]);

    const handleTabSelection = useCallback((tabId: TabId) => {
        if (selectedTabId !== undefined) { onChange?.(tabId); }
        setSelectedTabId(tabId);
    }, [onChange, selectedTabId]);

    const contextValue = useMemo(() => ({
        selectedTabId, setSelectedTabId: handleTabSelection, value, variant, isGrid, theme, overflow,
    }), [handleTabSelection, isGrid, selectedTabId, value, variant, theme, overflow]);

    return (
        <TabsContext.Provider
            value={contextValue}
        >
            {children}
        </TabsContext.Provider>
    );
}

export default Tabs;
